// Demo.js
import React, { useContext } from 'react';
import AuthContext from "../context/AuthProvider";
import {Link, Navigate} from "react-router";
import kampanya from "../assets/kampanya.png";
import havadurumu from "../assets/havadurumu.png";
import istanbul from "../assets/istanbul.png";
import trafik from "../assets/trafik.png";
import { Helmet } from 'react-helmet';
import FraudioLoader from "./FraudioLoader";

function Demo() {
    const { auth } = useContext(AuthContext);

    if (auth !== "demo@audiotime.com.tr") {
        return <Navigate to="/giris" />;
    }

    return (
        <React.Fragment>
            <Helmet>
                <script src={`${process.env.PUBLIC_URL}/assets/js/fraudio.min.js`} type="text/javascript" />
                <link rel="stylesheet" href={`${process.env.PUBLIC_URL}/assets/css/fraudio.css`} />
            </Helmet>

            <div className="breadcumb bg-overlay-one">
                <div className="breadcumb__bottom-thumb">
                    <img src="assets/images/thumb/banner-bid.png" alt="" />
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="breadcumb__wrapper">
                                <span className="breadcumb__title">
                                    <span className="breadcumb__title-lighten" style={{color:"#0a0a0a"}}>YAPAY ZEKA</span> DEMO
                                </span>
                                <ul className="breadcumb__list">
                                    <li className="breadcumb__item">
                                        <Link to="/" className="breadcumb__link" reloadDocument>
                                            <i className="las la-home" /> Ana Sayfa
                                        </Link>
                                    </li>
                                    <li className="breadcumb__item"> //</li>
                                    <li className="breadcumb__item-text">YAPAY ZEKA DEMO</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />

            {/* Hava Durumu (IP bazlı) */}
            <div className="live-youtube-wrapper style-two pb-120 pt-60 mt-0">
                <div className="container">
                    <div className="live-youtube style-two">
                        <div className="row gy-4 align-items-center">
                            <div className="col-lg-4">
                                <div className="youtube-rj">
                                    <div className="youtube-rj__thumb">
                                        <img src={havadurumu} alt="kampanya" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 ps-lg-5 pe-lg-5">
                                <div className="row">
                                    <div className="col-lg-7">
                                        <div className="youtube-content">
                                            <h6 className="youtube-content__subtitle">Hava durumu</h6>
                                            <h2 className="youtube-content__title" style={{ color: "#fff" }}>
                                                Kullanıcı IP'sine göre hava durumu
                                            </h2>
                                            <p className="youtube-content__desc">
                                                Radyo reklamlarında kullanıcıların bağlandığı IP'ye göre lokasyon tespiti yapıp, o lokasyona özel veri toplayarak otomatik olarak havadurumunu verir.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-lg-0 mt-3">
                                        <FraudioLoader src="https://audiotime.clerkai.app/havadurumu.php" title="Hava Durumu" artist="Yapay Zeka" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Hava Durumu (İstanbul) */}
            <div className="live-youtube-wrapper style-two pb-120 pt-60 mt-0">
                <div className="container">
                    <div className="live-youtube style-two">
                        <div className="row gy-4 align-items-center">
                            <div className="col-lg-4">
                                <div className="youtube-rj">
                                    <div className="youtube-rj__thumb">
                                        <img src={istanbul} alt="kampanya" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 ps-lg-5 pe-lg-5">
                                <div className="row">
                                    <div className="col-lg-7">
                                        <div className="youtube-content">
                                            <h6 className="youtube-content__subtitle">Hava durumu</h6>
                                            <h2 className="youtube-content__title" style={{ color: "#fff" }}>Kente göre hava durumu</h2>
                                            <p className="youtube-content__desc">
                                                Örneğin İstanbul gibi kentlere özel havadurumunu anlık olarak, radyolarda sunumunu sağlar.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-lg-0 mt-3">
                                        <FraudioLoader src="https://audiotime.clerkai.app/istanbul-havadurumu.php" title="İstanbul Hava" artist="Yapay Zeka" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Kampanya */}
            <div className="live-youtube-wrapper style-two pb-120 pt-60 mt-0">
                <div className="container">
                    <div className="live-youtube style-two">
                        <div className="row gy-4 align-items-center">
                            <div className="col-lg-4">
                                <div className="youtube-rj">
                                    <div className="youtube-rj__thumb">
                                        <img src={kampanya} alt="kampanya" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 ps-lg-5 pe-lg-5">
                                <div className="row">
                                    <div className="col-lg-7">
                                        <div className="youtube-content">
                                            <h6 className="youtube-content__subtitle">Geri sayım</h6>
                                            <h2 className="youtube-content__title" style={{ color: "#fff" }}>
                                                Kampanya reklamları
                                            </h2>
                                            <p className="youtube-content__desc">
                                                Günün belli aralıklarında yapılan kampanyalara güncel geri sayım yapan yapay zeka uygulamasıdır. Örnek seste hergün 14:00 ve 16:00 arası kampanyaya geri sayım yapmaktadır.
                                                Kampanya vakti geldiğinde, kampanyanın bitimine ne kadar kaldığını söylemektedir. O günün kampanyası bitmişse ertesi gün olacak kampanyaya geri sayım yapar.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-lg-0 mt-3">
                                        <FraudioLoader src="https://audiotime.clerkai.app/kampanya.php" title="Kampanya" artist="Geri Sayım" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Trafik */}
            <div className="live-youtube-wrapper style-two pb-120 pt-60 mt-0">
                <div className="container">
                    <div className="live-youtube style-two">
                        <div className="row gy-4 align-items-center">
                            <div className="col-lg-4">
                                <div className="youtube-rj">
                                    <div className="youtube-rj__thumb">
                                        <img src={trafik} alt="kampanya" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 ps-lg-5 pe-lg-5">
                                <div className="row">
                                    <div className="col-lg-7">
                                        <div className="youtube-content">
                                            <h6 className="youtube-content__subtitle">Trafik</h6>
                                            <h2 className="youtube-content__title" style={{ color: "#fff" }}>
                                                İstanbul Trafiğini anlık sunma
                                            </h2>
                                            <p className="youtube-content__desc">
                                                Yapay zeka verileri anlık derleyerek, İstanbul'daki son trafik durumunu verir.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-lg-0 mt-3">
                                        <FraudioLoader src="https://audiotime.clerkai.app/traffic.php" title="Trafik Durumu" artist="İstanbul" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment>
    );
}

export default Demo;
